import React from 'react';
import { Grid } from '@mui/material';
import { useSelector } from 'react-redux';
import {
  Cell,
  Legend,
  Pie,
  PieChart,
  ResponsiveContainer,
  Tooltip,
} from 'recharts';
import { RootState } from '../../../store';
import ChartPanel from '../components/ChartPanel';
import KpiCard from '../components/KpiCard';
import { CHART_COLORS } from '../components/scoreColors';
import { customError, lightTeal, successGreenAlt } from '../../../mainTheme';

const ConnectivitySection: React.FC = () => {
  const { connectivity } = useSelector((state: RootState) => state.callStats);
  const c = connectivity.data;
  const pie = c
    ? [
        { name: 'Host (direct)', value: c.ice.host, color: successGreenAlt },
        { name: 'STUN (srflx)', value: c.ice.srflx_stun, color: lightTeal },
        { name: 'TURN (relay)', value: c.ice.relay_turn, color: customError },
      ]
    : [];

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={6}>
        <ChartPanel
          title="ICE candidate type"
          subtitle="How calls connected — host vs STUN vs TURN relay"
          loading={connectivity.loading}
          error={connectivity.error}
          empty={!connectivity.loading && !c}
          mocked={connectivity.mocked}
          minHeight={280}
        >
          <ResponsiveContainer width="100%" height={280}>
            <PieChart>
              <Pie
                data={pie}
                dataKey="value"
                nameKey="name"
                innerRadius={60}
                outerRadius={95}
                paddingAngle={2}
              >
                {pie.map((e) => (
                  <Cell key={e.name} fill={e.color} />
                ))}
              </Pie>
              <Tooltip />
              <Legend />
            </PieChart>
          </ResponsiveContainer>
        </ChartPanel>
      </Grid>
      <Grid item xs={12} md={6}>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <KpiCard
              label="TURN (relay)"
              value={c ? `${c.turnPct}%` : '—'}
              accent={customError}
              sub="relayed media"
              mocked={connectivity.mocked}
            />
          </Grid>
          <Grid item xs={6}>
            <KpiCard
              label="STUN (srflx)"
              value={c ? `${c.stunPct}%` : '—'}
              accent={lightTeal}
              sub="server-reflexive"
            />
          </Grid>
          <Grid item xs={6}>
            <KpiCard
              label="Host (direct)"
              value={c ? `${c.hostPct}%` : '—'}
              accent={successGreenAlt}
              sub="LAN / direct"
            />
          </Grid>
          <Grid item xs={6}>
            <KpiCard
              label="Relayed calls"
              value={c ? c.ice.relay_turn : '—'}
              accent={CHART_COLORS[4]}
              sub="TURN-dependent"
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ConnectivitySection;
